import React, { useState, useEffect } from 'react'
import { Table, TableHead, TableBody, TableRow, TableCell, TextField, ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Typography, Divider } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

const template = {
  CUSTOMER_ID: {
    DOM: '',
    INTL: ''
  }
}

export const DemandManager = ({ expandAllVendors, options, allOptions, setOptions, setAllOptions, errors, setErrors, validation }) => {
  const { PREBID } = options
  const { VENDOR } = PREBID
  const { DM } = VENDOR
  const { CUSTOMER_ID } = DM
  const { DOM, INTL } = CUSTOMER_ID
  const { STRING } = validation
  const { LENGTH } = STRING
  const [expanded, setExpanded] = useState(expandAllVendors)
  PREBID.VENDOR.DM = DM

  useEffect(() => {
    setExpanded(expandAllVendors)
  }, [expandAllVendors])
  console.log("DemandManager Rendered with options: ", options)
  return (
    <ExpansionPanel expanded={expanded}>
      <ExpansionPanelSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls='DemandManager-panel-content'
        id='DemandManager-panel-header'
        onClick={() => setExpanded(!expanded)}
      >
        <Typography variant='h5'>DemandManager</Typography>
      </ExpansionPanelSummary>
      <Divider />
      <ExpansionPanelDetails>
        <Table size='small' aria-label='DemandManager-customer-id-table'>
          <TableHead>
            <TableRow>
              <TableCell style={{ width: '180px' }}><Typography variant='h6'>Customer IDs</Typography></TableCell>
              <TableCell>Domestic</TableCell>
              <TableCell>International</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell />
              <TableCell>
                <TextField
                  margin='none'
                  value={DOM}
                  error={errors.PREBID_DM_CIDD}
                  helperText={errors.PREBID_DM_CIDD && LENGTH.message}
                  onChange={(event) => {
                    console.log("Have Value ", event.target.value)
                    const value = event.target.value                    
                    PREBID.VENDOR.DM.CUSTOMER_ID.DOM = value
                    console.log("Set Value: ", PREBID.VENDOR.DM.CUSTOMER_ID.DOM)
                    setErrors({ ...errors, PREBID_DM_CIDD: value.length < LENGTH.min || value.length > LENGTH.max })
                    setOptions({ ...options, PREBID })
                    setAllOptions({ ...allOptions, PREBID })
                  }}
                />
              </TableCell>
              <TableCell>
                <TextField
                  margin='none'
                  value={INTL}
                  error={errors.PREBID_DM_CIDI}
                  helperText={errors.PREBID_DM_CIDI && LENGTH.message}
                  onChange={(event) => {
                    console.log("Have Value ", event.target.value)
                    const value = event.target.value
                    PREBID.VENDOR.DM.CUSTOMER_ID.INTL = value
                    console.log("Set Value: ", PREBID.VENDOR.DM.CUSTOMER_ID.INTL)
                    setErrors({ ...errors, PREBID_DM_CIDI: value.length < LENGTH.min || value.length > LENGTH.max })
                    setOptions({ ...options, PREBID })
                    setAllOptions({ ...allOptions, PREBID })
                  }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  )
}
